import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StudentFundingRequestVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrieveFundingRequests = createAsyncThunk<StudentFundingRequestVM[], void, { extra: Partial<Dependencies> }>(
  "fundingRequests/retrieveFundingRequests",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getAllFundingRequests();
  },
);
